<template>
  <div ref="posViewport" class="pos-viewport">
  <div id="pos-root" class="pos-root" :class="{'ordering-mode':orderingMode,'services-view':serviceView==='services'}">
    <div id="ordering-footer-slot"></div>
    <div v-if="modeMessage" class="mode-notice" role="status">{{modeMessage}} <button v-if="pendingMode!==null" @click="applyModeChange">Return to orders and apply mode</button></div>
    <div id="pos-orders-pane" class="pos-pane orders-pane"><orders-list-component
      ref="orders-list-component"
      :selected-order="selectedOrder" :ordering-mode="orderingMode"
      @updateOrder="selectOrder"
      :modal-opened="modalOpened"
    ></orders-list-component></div>
    <div class="pos-pane menu-pane"><menu-component :key="orderingMode ? 'ordering' : 'basic'" :selectedOrder="selectedOrder" :ordering-mode="orderingMode" :ordering-context="orderingContext"></menu-component></div>
    <div class="pos-pane order-pane"><selected-order-component
      ref="selected-order-component"
      :temp-order="selectedOrder ? selectedOrder : null"
      :ordering-enabled="orderingMode"
      @updateOrder="updateOrder"
      section="POS"
      @service-view="serviceView=$event"
      @ordering-context="orderingContext=$event"
      @showConfirm:drinkLimit="openDrinkLimitModal"
    ></selected-order-component></div>

  </div>
  </div>

  <teleport to="body">
    <confirm-modal ref="confirm-modal" />
    <countdown-timer-modal ref="countdown-timer-modal-component" />
  </teleport>
</template>

<script>
import axios from 'axios';
import {orderingModeMethods} from '@/_helpers/ordering-mode';
import SelectedOrderComponent from "@/components/pos/SelectedOrder";
import OrdersListComponent from "@/components/pos/OrdersList";
import MenuComponent from "@/components/pos/Menu";
import { settingsService } from "@/_api/settings.api";
import store from "@/store";
import getPosHelper from "@/_helpers/get-pos-helper";
import { init as initSettings } from "@/_helpers/settings";
import ConfirmModal from "@/components/_modals/ConfirmModal.vue";
import { constants } from "@/constants/constants";
import CountdownTimerModal from "@/components/_modals/CountdownTimerModal.vue";
import { taxesService } from "@/_api/taxes.api";

export default {
  name: "PosRootComponent",
  props: {},
  components: {
    CountdownTimerModal,
    ConfirmModal,
    MenuComponent,
    OrdersListComponent,
    SelectedOrderComponent,
  },
  data() {
    return {
      orderingMode:false, pendingMode:null, modeMessage:'', modeRequest:0, ordersOpen: false, selectedOrder: null, serviceView:'order', orderingContext:{seat:1,round:1},
      modalOpened: false,
      modalsOpened: [],
    };
  },
  computed: {
    authData() {
      return this.$store.state.auth;
    },
  },
  created() {},
  mounted() {
    this.getSettings();
    this.refreshOrderingMode();
    this.emmiter.on('refreshOrders', this.refreshOrderingMode);
    this.emmiter.on('orderingModeChanged', this.refreshOrderingMode);
    this.modeTimer=setInterval(()=>this.refreshOrderingMode(),5000);
    getPosHelper(this.authData.posId);

    this.emmiter.on("toggleModals", (data) => {
      if (data.opened) {
        if(!this.modalsOpened.includes(data.type))this.modalsOpened.push(data.type);
      } else {
        const index = this.modalsOpened.findIndex((i) => i === data.type);
        if (index !== -1) {
          this.modalsOpened.splice(index, 1);
        }
      }
      this.modalOpened = this.modalsOpened.length>0;
    });

    this.emmiter.on("showConfirm", (type) => {
      switch (type) {
        case "drinkLimit":
          this.openDrinkLimitModal();
          break;
        case "tabacco-payer":
        case "alcohol-payer":
          this.showPayerAgeRestrictionModal();
          break;
        case "alcohol":
          this.showAlcoholRestrictionModal();
          break;
        case "tabacco":
          this.showTabaccoRestrictionModal();
          break;
      }
    });

    this.emmiter.on("showTimer", (item) => {
      switch (item.type) {
        case "alcoholDrinkLimit":
          this.openAlcoholDrinkLimitModal(item.restrictedUntil);
          break;
      }
    });
  },
  beforeUnmount() {
    this.modeRequest++;
    clearInterval(this.modeTimer);
    this.emmiter.off('orderingModeChanged', this.refreshOrderingMode);
    this.emmiter.off('refreshOrders', this.refreshOrderingMode);
    this.emmiter.off("toggleModals");
    this.emmiter.off("showConfirm");
    this.emmiter.off("showTimer");
  },
  watch: {selectedOrder(){this.applyPendingMode();},modalOpened(){this.applyPendingMode();}},
  methods: {
    ...orderingModeMethods,
    modeDialogOpen(){return this.modalOpened || [...document.querySelectorAll('[aria-modal="true"], .ordering-overlay, .payment-workspace, .modal-mask')].some(el=>el.getClientRects().length);},
    applyModeChange(){
      if(this.modeDialogOpen()){this.modeMessage='Close or cancel the current dialog before applying the new terminal mode. Saved orders are retained.';return;}
      this.$refs['orders-list-component'].getOrders({resetList:true,resetSelected:true});
    },
    fetchOrderingMode(){return axios.get('/kitchen/mode');},
    selectOrder(order) { this.updateOrder(order); if (order) this.ordersOpen = false; },
    async getSettings() {
      try {
        const res = await settingsService.getSettings();
        initSettings(store, res.data);

        const taxRes = await taxesService.getActiveTax();
        const activeTax = taxRes?.payload?.content ?? null;

        store.dispatch("setActiveTax", activeTax);
      } catch (err) {
        console.error(err);
      }
    },

    updateOrder(data) {
      this.selectedOrder = data;
    },

    openDrinkLimitModal() {
      this.$refs["confirm-modal"].show({
        title:
          "This guest has reached the daily drink limit, they can no longer order alcoholic beverages until the end of the day",
        isSmallTitle: true,
        buttonLabel: "OK",
        classes: ["drink-limit"],
      });
    },

    showAlcoholRestrictionModal() {
      this.$refs["confirm-modal"].show({
        title: "Cannot purchase this package plan",
        message:
          "This guest’s cabin member is underage, so you cannot purchase a package plan that contains alcohol.",
        buttonLabel: "Ok",
      });
    },

    showPayerAgeRestrictionModal() {
      this.$refs["confirm-modal"].show({
        title: "Cannot purchase this package plan",
        message:
          "This payer(s) is underage, so you cannot purchase a package plan that contains alcohol or tabacco.",
        buttonLabel: "Ok",
      });
    },

    showTabaccoRestrictionModal() {
      this.$refs["confirm-modal"].show({
        title: "Cannot purchase this package plan",
        message:
          "This guest’s cabin member is underage, so you cannot purchase a package plan that contains tabacco.",
        buttonLabel: "Ok",
      });
    },

    openAlcoholDrinkLimitModal(expiredAt) {
      this.$refs["countdown-timer-modal-component"].show({
        title: constants.alcoholDrinksLimitModal.title,
        message: constants.alcoholDrinksLimitModal.message,
        expired_at: expiredAt,
        buttonLabel: constants.alcoholDrinksLimitModal.ok,
      });
    },
  },
};
</script>

<style scoped>
#pos-root {display:grid;grid-template: minmax(0,1fr) / minmax(160px,18%) minmax(220px,1fr) minmax(390px,42%);gap:8px;padding:8px;min-width:0;min-height:0;height:100%;overflow:hidden;box-sizing:border-box;align-items:stretch}
#pos-root > .pos-pane {min-width:0;min-height:0;height:100%}
#pos-root :deep(#orders-list),#pos-root :deep(#menu),#pos-root :deep(#selected-order){width:100%;height:100%;min-width:0;min-height:0;box-sizing:border-box}
.orders-pane{grid-area:1/1}.menu-pane{grid-area:1/2}.order-pane{grid-area:1/3}
.orders-toggle{display:none}
#pos-root.services-view{grid-template-columns:minmax(160px,20%) minmax(0,1fr)}
#pos-root.services-view > .menu-pane{display:none}
#pos-root.services-view > .order-pane{grid-area:1/2}
@media(max-width:1100px){
 #pos-root{grid-template:minmax(0,1fr)/minmax(160px,20%) minmax(220px,1fr) minmax(330px,40%)}
 #pos-root.services-view{grid-template-columns:20% minmax(0,1fr)}
}
.pos-viewport{height:100%;width:100%;min-height:0;min-width:0;overflow:hidden}
#pos-root{transform-origin:top left}
</style>
<style scoped>
#pos-root.ordering-mode{position:relative}#ordering-footer-slot{position:absolute;bottom:8px;left:calc(18% + 20px);right:8px;z-index:6}#pos-root.ordering-mode>.menu-pane{padding-bottom:50px}#pos-root.ordering-mode.services-view #ordering-footer-slot{left:calc(20% + 16px)}
@media(min-width:950px) and (max-width:1100px){#pos-root.ordering-mode{grid-template:minmax(0,1fr)/minmax(160px,20%) minmax(220px,1fr) minmax(330px,40%)}#pos-root.ordering-mode>.orders-toggle{display:none}#pos-root.ordering-mode>.orders-pane{position:static;grid-area:1/1;width:auto;height:100%;visibility:visible;pointer-events:auto;border:0;box-shadow:none}#pos-root.ordering-mode>.menu-pane{grid-area:1/2}#pos-root.ordering-mode>.order-pane{grid-area:1/3}#pos-root.ordering-mode.services-view{grid-template-columns:20% minmax(0,1fr)}#pos-root.ordering-mode.services-view>.order-pane{grid-area:1/2}#ordering-footer-slot{left:calc(20% + 16px)}}
@media(max-width:949px){#ordering-footer-slot,#pos-root.ordering-mode.services-view #ordering-footer-slot{left:calc(20% + 16px)}}
</style>

<style scoped>
@media(min-width:1101px){#pos-root.ordering-mode:not(.services-view){grid-template-columns:minmax(210px,22%) minmax(220px,1fr) minmax(390px,40%)}#pos-root.ordering-mode.services-view{grid-template-columns:minmax(210px,22%) minmax(0,1fr)}#pos-root.ordering-mode #ordering-footer-slot{left:calc(22% + 18px)}}
</style>

<style scoped>
.mode-notice{position:absolute;bottom:60px;left:8px;max-width:320px;z-index:30;padding:10px;background:#fff4d7;border:1px solid #c79f38;color:#413311;font-size:13px}
</style>
